import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { NavLink } from "reactstrap";

export class GestionSignature extends Component {

    render = () => {

        const chemin = window.location.pathname;
        const baseUrl = "/Configuration/GestionSignature";
        const onglets = [
            { url: "/Eiffage", titre: "Eiffage" }
        ];
        const onAffiche = chemin === baseUrl
            || typeof onglets.find(onglet => chemin.startsWith(baseUrl + onglet.url)) !== "undefined";

        return <nav className="navbar navbar-expand-lg navbar-light border-bottom">
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarAPI" aria-controls="navbarAPI" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarAPI">
                <ul className="navbar-nav">
                    {onAffiche && onglets.map((onglet, index) => {
                        const { url, titre, hidden } = onglet;
                        const urlComplete = baseUrl + url;
                        return !hidden && <li key={index} className={`nav-item ${chemin.startsWith(urlComplete) ? `active` : ""}`}>
                            <NavLink tag={Link} className="text-dark" to={urlComplete}>{titre}</NavLink>
                        </li>;
                    })}
                </ul>
            </div>
        </nav>;

    };

}